/** Site-wide constants. Set NEXT_PUBLIC_SITE_URL at deploy for correct canonicals/OG. */
export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL ?? "http://localhost:3000";
export const SITE_NAME = "Yassine Amraoui";
/** Search-first: people search the service, not the name. Brand rides last. */
export const SITE_TITLE = "UI/UX Designer & Developer: Apps, Games, 3D & AI — Yassine Amraoui";
/** ≤ 155 characters, so search results show all of it. */
export const SITE_DESCRIPTION =
  "Independent creator turning ideas into real products: apps, games, 3D and AI training experiences, and websites. Designed (UI/UX) and built by one person.";

/** Cut a long text at a word boundary for a meta description (search shows ~155 chars). */
export function metaDescription(text: string, max = 155): string {
  if (text.length <= max) return text;
  return `${text.slice(0, max - 1).replace(/\s+\S*$/, "").replace(/[,;:—-]$/, "")}…`;
}
/** How he introduces himself on the page. A creator, not one trade: websites are one of the things he makes. */
export const ROLE = "Creator, from idea to working product";
/** What he makes, in the order he wants it read. */
// e-learning is hidden for now (2026-10-14); restore it from git history when it comes back
export const MAKES = ["apps", "games", "3D and AI training simulations", "immersive 3D and AI experiences", "websites"];
/**
 * The definitional sentence answer engines should quote. Reused by the FAQ,
 * JSON-LD and llms.txt so every place describes him the same way.
 */
export const IDENTITY =
  "Yassine Amraoui is an independent creator who turns ideas into real, working products: apps, games, 3D and AI training simulations, immersive 3D and AI experiences, and websites. He designs the experience (UI/UX) and builds it himself, end to end, working remotely with clients worldwide.";
/** Query phrases the site targets; feeds meta keywords and llms.txt. */
export const SERVICE_KEYWORDS = [
  "UI/UX designer and developer",
  "turn an idea into an app",
  "freelance app developer",
  "game developer for hire",
  "serious games",
  "interactive product designer",
  "freelance web designer",
  "creative developer",
  "remote web developer",
  "business website design and development",
  "full-stack web app developer",
  "3D training simulation developer",
  "AI training simulation",
  "Unity 3D developer for hire",
  "AI integration developer",
  "interactive 3D website",
  "motion design website",
  "Next.js developer freelance",
  "scroll animation website",
];
/** Last time the portfolio content changed; drives sitemap lastmod (bump it when the work changes). */
export const CONTENT_UPDATED = "2026-10-14";
export const CONTACT_EMAIL = "contact@yassineamraoui.com";
export const LINKEDIN = "https://www.linkedin.com/in/yassine-amraoui-4810921a1";
export const GITHUB = "https://github.com/ni-ssay";

export function absUrl(path: string): string {
  return `${SITE_URL}${path === "/" ? "" : path}`;
}
